import Languages from '../../../../utils/Languages.js'
import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {button, card, field, intro, mailDocument, multiline, stack} from './mailLayout.js'

// Also the welcome mail for users (userWelcomeTemplate): the message, the login name and a button to create a password
export const welcomeTemplate = ({logo, color = '#ff751a', message, url, token, loginEmail = '', photo = ''}: {
    logo: string
    color?: string
    message: string
    url?: string
    token: string
    loginEmail?: string
    // Url of the reseller's photo for the welcome mail, at the top
    photo?: string
}, baseUrl?: string) => {
    return mailDocument({
        logo,
        color,
        photo,
        baseUrl,
        content: stack([
            intro(multiline(message)),
            card([
                field(Languages.mailLoginName.NL, loginEmail),
                button(Languages.mailCreatePassword.NL, `${url || ''}/wachtwoordwijzigen/${token}`, color)
            ])
        ])
    })
}

export default escapedTemplate(welcomeTemplate)
